export const IntegrationProductTypeColumns = {
	model: [
		{
			label: 'Product Id',
			key: 'key',
		},
		{
			label: 'Product Name',
			key: 'label'
		},
	],
	formBuilderConfig: {
		key: {
			DataType: 'String',
			DisplayText: 'Product Id',
			Name: 'key'
		},
		label: {
			DataType: 'String',
			DisplayText: 'Product Name',
			Name: 'label'
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}
